var path = '/pages/guestlists/views/pages/guestlists/messages/templates.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n<al-guestlist-templates guestlist=\"vm.guestlist\" ng-if=\"!vm.loading\"></al-guestlist-templates>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/guestlists/messages/templates.tpl.html
// module id = 2264
// module chunks = 1